import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { Modal, PrimaryButton } from '../../components';
import SkiBootsTab from './SizeModalTabs/SkiBoots';
import SkiSticksTab from './SizeModalTabs/SkiSticks';
import SnowboardTab from './SizeModalTabs/Snowboard';
import SkiTab from './SizeModalTabs/Ski';

import css from './ListingPage.css';

const TABS = [
  { id: 'ski', label: 'SizesModal.ski', component: SkiTab },
  { id: 'skiBoots', label: 'SizesModal.skiBoots', component: SkiBootsTab },
  { id: 'skiSticks', label: 'SizesModal.skiSticks', component: SkiSticksTab },
  { id: 'snowboard', label: 'SizesModal.snowboard', component: SnowboardTab }
]

const SizesModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    productCategory,
  } = props;

  const [activeTab, setActiveTab] = useState(productCategory === 'wintersports_snowboard' ? 'snowboard' : 'ski');

  const classes = classNames(rootClassName || css.rootSizeModal, className);
  const closeButtonMessage = intl.formatMessage({ id: 'SizesModal.later' });

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={classNames(css.modalContent)}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={() => { }}
      usePortal
      closeButtonMessage={closeButtonMessage}
    >
      <div className={css.sizeModalContent}>
        <h2 className={css.sizeModalHeader}>
          <FormattedMessage id="SizesModal.header" />
        </h2>
        <div className={css.tabs}>
          {
            TABS.map((tab) => (
              <button key={tab.id} className={classNames(css.tab, {[css.active]: tab.id === activeTab})} onClick={() => setActiveTab(tab.id)}>
                <FormattedMessage id={tab.label} />
              </button>
            ))
          }    
        </div>
        <div>
          {
            TABS.map((tab) => {
              const Component = tab.component;
              return tab.id === activeTab ? <Component key={tab.id} intl={intl}/> : null
            })
          }
        </div>
        <PrimaryButton onClick={onCloseModal} className={css.closeButton}>
          <FormattedMessage id="SizesModal.close" />
        </PrimaryButton>
      </div>
    </Modal>
  );
};

SizesModal.defaultProps = {
  className: null,
  rootClassName: null,
  reviewSent: false,
  sendReviewInProgress: false,
  sendReviewError: null,
};

export default injectIntl(SizesModal);